// src/data/SliderData.js
import slider1 from '../assets/images/slider1.jpg';
import slider2 from '../assets/images/slider2.jpg';
import slider3 from '../assets/images/slider3.jpg';
import slider4 from '../assets/images/slider4.jpg';
import slider5 from '../assets/images/slider5.jpg';
import slider6 from '../assets/images/slider6.jpg';
import slider7 from '../assets/images/slider7.jpg';
import slider8 from '../assets/images/slider8.jpg';
import slider9 from '../assets/images/slider9.jpg';

const SliderData = [
  { 
    image: slider1, 
    title: "Unlock Your Potential", 
    description: "Join our tuition-free programs in AI, Cybersecurity, and Data Science tailored for African students.", 
    link: "/ai-pricing", 
    buttonText: "Start Learning",
    color: "#1890ff" // Blue
  },
  { 
    image: slider2, 
    title: "Innovate with AI", 
    description: "Explore cutting-edge AI solutions and mentorship opportunities to shape the future.", 
    link: "/data-science-ai", 
    buttonText: "Discover AI Solutions",
    color: "#40a9ff" // Lighter blue
  },
  { 
    image: slider3, 
    title: "Secure the Digital World", 
    description: "Master cybersecurity skills with hands-on training and real-world challenges.", 
    link: "/cyber-threat-detection", 
    buttonText: "Learn Cybersecurity",
    color: "#e50325" // Red
  },
  { 
    image: slider4, 
    title: "Empowering Africa's Future", 
    description: "100% Online, Tuition-Free AI, Machine Learning, Cybersecurity, and Data Science Education for Underprivileged Students.", 
    link: "/ai-pricing", 
    buttonText: "Explore Learning Plans",
    color: "#1890ff" // Blue
  },
  { 
    image: slider5, 
    title: "Data-Driven Insights", 
    description: "Gain expertise in Data Science and Analytics with our free online courses.", 
    link: "/data-engineering-analytics", 
    buttonText: "Dive into Data Science",
    color: "#52c41a" // Green
  },
  { 
    image: slider6, 
    title: "Build the Future", 
    description: "Develop custom software and applications with expert guidance.", 
    link: "/custom-software", 
    buttonText: "Start Building",
    color: "#722ed1" // Purple
  },
  { 
    image: slider7, 
    title: "Join Our Community", 
    description: "Connect with mentors, peers, and industry leaders in our vibrant community.", 
    link: "/community", 
    buttonText: "Join Now",
    color: "#13c2c2" // Cyan
  },
  { 
    image: slider8, 
    title: "Real-World Projects", 
    description: "Work on impactful projects and showcase your skills to the world.", 
    link: "/projects", 
    buttonText: "View Projects",
    color: "#fa8c16" // Orange
  },
  { 
    image: slider9, 
    title: "Scholarships for Africa", 
    description: "Access exclusive scholarship opportunities to kickstart your career.", 
    link: "/africa-scholarships", 
    buttonText: "Apply for Scholarships",
    color: "#eb2f96" // Pink
  },
];

export default SliderData;